import React from 'react';
import { Toaster } from 'sonner';
import ReactDOM from 'react-dom';

const ToastContainer = () => {
  return ReactDOM.createPortal(
    <Toaster
      position={'bottom-right'}
      closeButton
      duration={5000}
      className="se-toast-container"
      toastOptions={{
        unstyled: false,
        classNames: {
          toast: 'se-toast',
          title: 'se-toast-title se-text-[14px] se-font-bold',
          description: 'se-toast-description',
          content: 'se-toast-content',
          icon: 'se-toast-icon',
          actionButton: 'se-toast-action-btn',
          cancelButton: 'se-toast-cancel-btn',
          closeButton: 'se-toast-close-btn',
          loader: 'se-toast-loader',
          success: 'se-toast-success',
          error: 'se-toast-error',
          info: 'se-toast-info',
          warning: 'se-toast-warning',
          loading: 'se-toast-loading',
          default: 'se-toast-default',
        },
      }}
      icons={{
        success: '',
        info: '',
        warning: '',
        error: '',
        loading: '',
      }}
    />,
    document.body,
  );
};

export default ToastContainer;
